import React from "react";
import { BrowserRouter as Router, Route, Switch, Link } from "react-router-dom";
//import HLogin from "./home";
import Home from "./App";
import aboutUs from "./about";
import intProcess from "./integrationProcess";
import whatWeOffers from "./whatWeOffer";
import traCentre from "./traningcentre";
import OrdPro from "./orderPro";
import packinf from "./packInfo";
import custRet from "./custReturn";
import WhyCLiQ from "./whyChoose";

function ExperienceZoneRoute() {
  return (
    <Router>
      <div>
        <Switch>
          <Route path="/experiencezone/" exact component={Home} />
          <Route path="/experiencezone/about" component={aboutUs} />
          <Route
            path="/experiencezone/intergration-process"
            component={intProcess}
          />
          <Route
            path="/experiencezone/what-we-offer"
            component={whatWeOffers}
          />
          <Route path="/experiencezone/traning-centre" component={traCentre} />
          <Route path="/experiencezone/order-processing" component={OrdPro} />
          <Route
            path="/experiencezone/packaging-information"
            component={packinf}
          />
          <Route path="/experiencezone/customer-returns" component={custRet} />
          <Route path="/experiencezone/why-choose-us" component={WhyCLiQ} />
        </Switch>
      </div>
    </Router>
  );
}

export default ExperienceZoneRoute;
